import React, { useContext } from 'react'
import { WrapReports } from './Style'
import { CustomSection, IconButtonGroups, LightButton, Space } from 'styles/GlobalStyle'
import { Record } from 'components'
import { Page } from 'pages'
import { ratingHooks, ReportHeader } from '.'
import { IconButtons } from 'components/Form'
import { ReportContext } from './ReportContext'
import { BlockedReportStyles } from './Style'
import { useTheme } from 'styles'
import { useSelector } from 'react-redux'
import { keyBy } from 'lodash'
import { prosodies, semesters } from 'keys'
import { getSemester } from 'utils/general'
import { ratingListLabel2, ratingListLabel5, ratingListLabel6 } from 'keys/rating'
import { assessmentHooks } from '../Assessment'

const Rating = (props) => {
    const { hideHeader } = props
    const { setReportDisplay, reportDisplay } = useContext(ReportContext)
    const { Layout } = useTheme()
    const { rating } = useSelector(state => state.rating)
    const { assessment } = useSelector(state => state.assessment)
    const { fluency_reading, fluency_reading_rating_id, fluency_reading_rating_index, factored_percent_accuracy_rating_index, percent_accuracy_rating_id, percent_accuracy_rating_index, correct_words_per_minute = "?", words_per_minute_rating_id, words_per_minute_rating_index, correct_words_per_minute_rating_index, correct_words_per_minute_rating_id } = rating || {}

    const reportDisplayBtns = ratingHooks.useReportDisplayBtns()
    const reportDisplayBtnKeys = keyBy(reportDisplayBtns, "key")
    const viewItem = reportDisplay ? reportDisplayBtnKeys[reportDisplay] : reportDisplayBtns[0]

    const currentSemester = getSemester(assessment.create_date)
    const semestersKeys = keyBy(semesters, "id")
    const semester = semestersKeys?.[currentSemester]
    const prosodyKeys = keyBy(prosodies, "id")
    const matchingLeraningBtn = ratingHooks.useMatchingLeraningBtn(props.assessmentID)
    const checkBlurredAssesment = assessmentHooks.useGetBlurredAssesment()

    return (
        <Page assessmentID={props.assessmentID}>
            {hideHeader || <ReportHeader {...props} />}
            {checkBlurredAssesment(assessment) ?
                <BlockedReportStyles>
                    <div>{"סליחה....."}</div>
                    <div>{'אבל הדו"ח נחסם לצפיה,'}</div>
                    <Space />
                    <div>{'נא לפנות אל רכזת השפה הבית ספרית'}</div>
                </BlockedReportStyles>
                :
                <WrapReports>
                    <div style={{ ...Layout.fullWidth, ...Layout.colHCenter, ...Layout.mrGap }}>
                        <div style={{ ...Layout.flex, ...Layout.justifyContentEnd }}>
                            <IconButtonGroups>
                                <IconButtons
                                    btns={reportDisplayBtns}
                                    setSelected={(e, val) => setReportDisplay(val)}
                                    selected={reportDisplay}
                                />
                            </IconButtonGroups>
                        </div>
                    </div>

                    <CustomSection $flex={false} $bg $shrink height={130}>
                        <Record id="rating" />
                    </CustomSection>
                    <div className='wrap-assessment-content'>
                        <div className='profile-and-button'>
                            <div className='reading_profile'>
                                {rating &&
                                    <React.Fragment>
                                        {"דירוג קריאה "}
                                        <b>{"למבדק זה: "}</b>
                                        {`קריאה ${ratingListLabel5[words_per_minute_rating_index - 1]}`}{", "}
                                        {`ברמת דיוק ${ratingListLabel2[factored_percent_accuracy_rating_index - 1]}`}{", "}
                                        {`בצורה ${ratingListLabel6[fluency_reading_rating_index - 1]}`}
                                        {assessment.prosody && <>{", "}{`עם פרוזודיה ${prosodyKeys[assessment.prosody].name2}`}</>}
                                    </React.Fragment>
                                }
                            </div>
                            <LightButton variant="solid" {...matchingLeraningBtn} />
                        </div>
                        <viewItem.component
                            category={assessment?.reading_assessment_category}
                            ability_groups={assessment?.reading_assessment_ability_groups}
                            assessmentID={props.assessmentID}
                        />
                    </div>
                </WrapReports>}
        </Page>
    )
}

export default Rating